module.exports = __webpack_public_path__ + "static/img/stupa.f990914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/stupa.jpg
// module id = IlYA
// module chunks = 1